import React, { useState } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {Form} from "react-bootstrap";

import { makeStyles } from '@material-ui/core';  
import { useFormik } from "formik";
import * as Yup from "yup";
import * as auth from "../_redux/authRedux";
import { newPassword } from "../_redux/authCrud";
import { hashPassord } from '../../../utils/hashUtility';


const useStyles = makeStyles(theme => ({
  alertMsg: {
    color: 'red'
  }
}));
const initialValues = {
  npassword: "",
  cpassword: "",
  q1:"",
  ans1: "",
  ans2: "",
  q2:""

};

export function ResetPassword(props) {
  let questions=[];
  let email="";
  if (props.history.location.state!==undefined) {
    questions=props.history.location.state.questions;
    email=props.history.location.state.email;
  }
  // const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [responseStatus, setResponse] = useState(false);
  const [errorMsg, setMessage] = useState("");
  const ResetPasswordSchema = Yup.object().shape({
    npassword: Yup.string()
      .min(8, "Minimum 8 symbols")
      .max(50, "Maximum 50 symbols")
      .required("new password is a required field"),
    cpassword: Yup.string()
      .min(8, "Minimum 8 symbols")
      .max(50, "Maximum 50 symbols")
      .required("confirm password is a required field"),
    ans1: Yup.string()
      .required("answer is a required field"),
    ans2: Yup.string()
      .required("answer is a required field"),
    q1: Yup.string()
      .required("question is a required field"),
    q2: Yup.string()
      .required("question is a required field")
      
  });

  const classes = useStyles();

  const enableLoading = () => {
    setLoading(true);
  };
  const disableLoading = () => {
    setLoading(false);
  };
  // const disableMessage = () => {
  //   setResponse(false);
  // }
  const enableMessage = () => {
    setResponse(true);
  }

  // const getInputClasses = (fieldname) => {
  //   if (formik.touched[fieldname] && formik.errors[fieldname]) {
  //     return "is-invalid";
  //   }

  //   if (formik.touched[fieldname] && !formik.errors[fieldname]) {
  //     return "is-valid";
  //   }

  //   return "";
  // };

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      if (values.cpassword===values.npassword) {
        let digest = hashPassord(email,values.cpassword);
        let question1=parseInt(values.q1);
        let question2=parseInt(values.q2);
        let answer1 = hashPassord(values.ans1);
        let answer2 = hashPassord(values.ans2);
        enableLoading();
        newPassword(email,digest,question1,answer1,question2,answer2)
        .then((res) => {
        if (res.data.status) {
          setSubmitting(false);
          disableLoading();
          enableMessage();
          setMessage(res.data.message);
          props.history.push('/auth/verify-code',{email:email,password:digest});
        }
      })
        .catch((error) => {
          setSubmitting(false);
          disableLoading();
          enableMessage();
          setMessage(error.response.data.message);
          // setStatus(
          //   intl.formatMessage(
          //     { id: "AUTH.VALIDATION.NOT_FOUND" },
          //     { name: values.email }
          //   )
          // );
        });
      } else {
            setSubmitting(false);
            enableMessage();
            setMessage("Passwords do not match")
            disableLoading();
      }
    }
  });

  let listQuestions;
  if (questions!==undefined && questions!=null) {
    listQuestions=questions.map((res)=>{
      return <option key={res.id} value={res.id}>{res.question}</option>
    })
  } else{
    listQuestions='';
  }

  return (

    <div>
      <div className="vertical-center outer">
        <div className="shadow-lg box">
          <div align="center">
            <h3 style={{width:"100%"}}><b>Reset Passsword</b></h3>
          </div>
          <div align="center" >
            <Form style={{marginTop:"10%"}}>

            <Form.Group controlId="formGroupNpassword">
                <div align="left"><Form.Label>New Password</Form.Label></div>
                <Form.Control className="form-control" type="password" style={{border:"1px solid black"}} name="npassword"
                    {...formik.getFieldProps("npassword")}
                    required/> 
                    {formik.touched.npassword && formik.errors.npassword ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block d-flex p-2">{formik.errors.npassword}</div>
                    </div>
                  ) : null}
              </Form.Group>

              <Form.Group controlId="formGroupCpassword">
                <div align="left"><Form.Label>Confirm Password</Form.Label></div>
                <Form.Control className="form-control" type="password" style={{border:"1px solid black"}} name="cpassword"
                    {...formik.getFieldProps("cpassword")}
                    required/> 
                    {formik.touched.cpassword && formik.errors.cpassword ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block d-flex p-2">{formik.errors.cpassword}</div>
                    </div>
                  ) : null}
                </Form.Group>

                <Form.Group controlId="formGroupCSQ1">
                    {/* <Form.Label><h5>select 2 questions and answers</h5></Form.Label> */}
                    <div align="left"><Form.Label>Security Question 1</Form.Label></div>
                    <Form.Control as="select" {...formik.getFieldProps("q1")} style={{border:"1px solid black"}}
                    required>
                      <option></option>
                      {listQuestions}
                    </Form.Control>
                    {formik.touched.q1 && formik.errors.q1 ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block d-flex p-2">{formik.errors.q1}</div>
                    </div>
                  ) : null}<br/>
                    <div align="left"><Form.Label>Answer</Form.Label></div>
                    <Form.Control className="form-control" type="text" style={{border:"1px solid black"}} name="ans1"
                    {...formik.getFieldProps("ans1")}
                    required/> 
                    {formik.touched.ans1 && formik.errors.ans1 ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block d-flex p-2">{formik.errors.ans1}</div>
                    </div>
                  ) : null}
                </Form.Group>

                <Form.Group controlId="formGroupCSQ2">
                <div align="left"><Form.Label>Security Question 2</Form.Label></div>
                    <Form.Control as="select" {...formik.getFieldProps("q2")} style={{border:"1px solid black"}}
                    required>
                      <option></option>
                      {listQuestions}
                    </Form.Control>
                    {formik.touched.q2 && formik.errors.q2 ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block d-flex p-2">{formik.errors.q2}</div>
                    </div>
                  ) : null}<br/>
                    <div align="left"><Form.Label>Answer</Form.Label></div>
                    <Form.Control className="form-control" type="text" style={{border:"1px solid black"}} name="ans2"
                    {...formik.getFieldProps("ans2")}
                    required/> 
                    {formik.touched.ans2 && formik.errors.ans2 ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block d-flex p-2">{formik.errors.ans2}</div>
                    </div>
                  ) : null}
                </Form.Group>
              
            </Form>
            <div align="center" style={{marginTop:"20%"}}>
              <div className="btn btn-lg btn-block vertical-center" style={{cursor: "pointer",border:"1px solid black"}} onClick={formik.handleSubmit}><span><b>Reset Password</b></span>{loading && <span className="ml-3 spinner spinner-dark"></span>}</div>
              {responseStatus ? (<div className={`d-flex p-2 ${classes.alertMsg}`}>{errorMsg}</div>) : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ResetPassword));